module.exports = __webpack_public_path__ + "static/img/NP.d27b8565.svg";